import React, { useState } from 'react';

//holds all ui update config
const initialState = {

    consentData:
        [
            { id: '1', name: 'byEmail', text: 'Please notify me of future Virtual Tour updates by email' },
            { id: '2', name: 'byText', text: 'Please notify me of future Virtual Tour updates by text message' },
        ],

    acceptTAndC: { id: '1', name: 'acceptTAndC', text: 'I have read and agreed to Terms and Conditions' },

    acceptCEM: { id: '1', name: 'acceptCEM', text: 'I have read and agreed to provide Commercial Electronic Message Consent' },

    contactMe: { id: '1', name: 'contactMe', text: 'Please have my rep or AgSolutions Customer Care contact me about questions I have.' },

    provinces: [
        { id: 1, text: 'Alberta' },
        { id: 2, text: 'British Columbia' },
        { id: 3, text: 'Manitoba' },
        { id: 4, text: 'New Brunswick' },
        { id: 5, text: 'Newfoundland and Labrador' },
        { id: 6, text: 'Northwest Territories' },
        { id: 7, text: 'Nova Scotia' },
        { id: 8, text: 'Nunavut' },
        { id: 9, text: 'Ontario' },
        { id: 10, text: 'Prince Edward Island' },
        { id: 11, text: 'Quebec' },
        { id: 12, text: 'Saskatchewan' },
        { id: 13, text: 'Yukon' }
    ]
}

export const InputConfig = React.createContext(initialState);

export const InputConfigProvider = (props) => {

    const [inputConfig, inputUpdate] = useState(initialState);

    return (
        <InputConfig.Provider value={[inputConfig, inputUpdate]}>
            {props.children}
        </InputConfig.Provider>
    )
}
